import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "top" as const,
    },
    title: {
      display: false,
      text: "Chart.js Line Chart",
    },
    elements: {
      line: {
        tension: 0.4, // Adjust the tension to control the curve
      },
    },
  },
};

const LineChart = ({ data }: { data: any }) => {
  data.datasets.forEach((dataset: any) => {
    dataset.cubicInterpolationMode = "monotone";
  });
  return <Line options={options} data={data} />;
};

export default LineChart;
